<template>
  <div>
    Details
  </div>
  <div>
    <mf-table
      ref="shippingListDelivery"
      :tableProps="tableProps"
      :loadData="loadData"
      tableName="sendShippingLists"
      :hideGutter="true"
      :api-mode="false"
      :key="rerenderMfTable"
      :checkedRows="selectedDeliveries"
      @checkbox-toggled="getSelectedRow">
      <template v-slot:shippingStatus="{ rowData: delivery }">
        <field-stage
          :isEditing="true"
          :shipType="delivery.shipType"
          :value="delivery.status"
          :shippingItems="delivery.items"
          :isStatus="true"
        ></field-stage>
      </template>
      <template #shipBy="{ rowData, rowField }">
        <custom-date-picker
          :rowData="rowData"
          :rowField="rowField"/>
      </template>
      <template #deliverBy="{ rowData, rowField }">
        <custom-date-picker
          :rowData="rowData"
          :rowField="rowField"/>
      </template>
    </mf-table>
  </div>
</template>

<script>
  import { computed, inject, reactive, ref, toRefs } from 'vue';
  import { defineComponent } from 'vue';
  import MfTable from '@/components/table-fields/MfTable.vue';
  import CustomDatePicker from '@/components/CustomDatePicker.vue';
  import shippingListsDeliveriesTabCols from '../table-cols/shippingListsDeliveriesTabCols';

  export default defineComponent({
    props: {
      rowData: {
        type: Object,
        default: () => {},
      },
      deliveries: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      MfTable,
      'custom-date-picker': CustomDatePicker,
    },
    setup(props, { emit }) {
      const emitter = inject('emitter');
      const shippingListDelivery = ref(null);
      const state = reactive({
        data: props.rowData.partialShipments,
        rerenderMfTable: 0,
        selectedDeliveries: props.deliveries,
      });

      const getSelectedRow = (delivery) => {
        state.selectedDeliveries = delivery;
        emitter.emit('deliveriesList', state.selectedDeliveries);
      };

      const tableProps = computed(() => ({
        isDetailed: false,
        toolBar: false,
        hideTableGutter: true,
        showHeader: true,
        isCheckable: true,
        fields: shippingListsDeliveriesTabCols.fields,
      }));

      const loadData = () => state.data.filter((data) => data.status !== "unscheduled");

      return {
        ...toRefs(state),
        tableProps,
        loadData,
        shippingListDelivery,
        getSelectedRow,
      }
    }
  })
</script>